import * as d3 from "d3";
import { abbreviateLabel } from "./textHelper";
import { useEffect, useRef, useState } from "react";

//Constantes

const COLOR_GRID = "#525252"; //color del grid
const RADIO_INTERIOR = 1; //tamaño del circulo interno central
const MARGIN = 20; //margen de la figura las lineas y areas

//tipos
type AxisConfig = {
  name: string; //nombre que aparece en el gráfico
  maxValue: number; // el valor maximo en ese respectivo eje
};

type RadarGridProps = {
  outerRadius: number; //tamaño de los circulo exterior
  xScale: d3.ScaleBand<string>; //donde estaran los labels
  axisConfig: AxisConfig[];
  widthX: number;
};

type YScale = d3.ScaleRadial<number, number, never>; //Scalas

// type DataItem = {
//   [key: string]: number;
// } & {
//   name: string;
//   colorLine: string;
// };

type SpiderChartProps = {
 
  data: any;
  axisConfig: AxisConfig[];
};
const RadarGrid = ({ outerRadius, xScale, axisConfig, widthX }: RadarGridProps) => {
  const lineGenerator = d3.lineRadial();
  console.log("SDSWDW", widthX)
  // Compute Axes = from center to outer
  const allAxes = axisConfig.map((axis, i) => {
    const angle = xScale(axis.name);

    if (angle === undefined) {
      return null;
    }

    const path = lineGenerator([
      [angle, RADIO_INTERIOR],
      [angle, outerRadius],
    ]);

    if (path === null) {
      return null;
    }

    const labelPosition = polarToCartesian(
      angle - Math.PI / 2,
      outerRadius + 10
    );
    

    return (
      <g key={`WeberGrid${i}`}>
      
        <path
          key={`Path${i}`}
          d={path}
          stroke={COLOR_GRID}
          strokeWidth={0.5}
          rx={1}
        />

        <text
          className="axis-label"
          x={labelPosition.x}
          y={labelPosition.y}
          fontSize={12}
          fill={COLOR_GRID}
          textAnchor={labelPosition.x > 0 ? "start" : "end"}
          dominantBaseline="middle"
        >
          { widthX > 300 ? (axisConfig.length > 11 ?
            abbreviateLabel(axis.name,4):
            abbreviateLabel(axis.name,24))
            : ( axisConfig.length > 11 ?
            abbreviateLabel(axis.name,4):
            abbreviateLabel(axis.name,6)
            ) }
          <title>{axis.name}</title>
        </text>
      </g>
    );
  });
  const tickValues = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
  // AAA circulos
  const yScale = d3.scaleLinear()
    .domain([0, 100])
    .range([RADIO_INTERIOR, outerRadius]);

  // Generate circles for each tick value
  const allCircles = tickValues.map((value, i) => {
    const radius = yScale(value);
    return (
      <g key={`circle-group-${i}`}>
        <circle
          cx={0}
          cy={0}
          r={radius}
          stroke={COLOR_GRID}
          fill="none"
        />
        <text
          x={radius + 6}
          y={0}
          fontSize={9}
          fill={COLOR_GRID}
          textAnchor="middle"
          dominantBaseline="middle"
        >
          {value}
        </text>
      </g>
    );
  });
  return (
    <g>
      {allAxes}
      {allCircles}
    </g>
  );
};

const SpiderChart = ({  data, axisConfig }: SpiderChartProps) => {

  const svgRef = useRef<SVGSVGElement | null>(null);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const svgElement = svgRef.current;
    if (svgElement) {
      const { width, height } = svgElement.getBoundingClientRect();
      setDimensions({ width, height });
    }

    const handleResize = () => {
      if (svgElement) {
        const { width, height } = svgElement.getBoundingClientRect();
        setDimensions({ width, height });
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const outerRadius = Math.min(dimensions.width, dimensions.height) / 2 - MARGIN;

  // Creamos una escala para que tengamos un angulo por cada nombre
  const allVariableNames = axisConfig.map((axis) => axis.name);
  const xScale = d3
    .scaleBand()
    .domain(allVariableNames)
    .range([0, 2 * Math.PI]);

  // Provides the distance to the center.
  let yScales: { [name: string]: YScale } = {};
  axisConfig.forEach((axis) => {
    yScales[axis.name] = d3
      .scaleLinear()
      .domain([0, axis.maxValue])
      .range([RADIO_INTERIOR, outerRadius]);
  });

  // Realiza las formas seria la linea una por categoria
  const lineGenerator = d3.lineRadial();
  let pointOut:any[]=[]
  const allGroups = data.map((series: any, i: any) => {
    const allCoordinates = axisConfig.map((axis) => {
      const yScale = yScales[axis.name];
      const angle = xScale(axis.name) ?? 0;
      const radius = yScale(series[axis.name]);
      const coordinate: [number, number] = [angle, radius];
      return coordinate;
    });

    //Se cierra los puntos
    allCoordinates.push(allCoordinates[0]);
    const linePath = lineGenerator(allCoordinates);

    if (linePath === null) {
      return null;
    }

    const cordinatess = allCoordinates
    cordinatess.pop()
    const points = cordinatess?.map(([angle, radius], index) => {
      const position = polarToCartesian(angle - Math.PI / 2, radius);
      return (
        <circle
          key={`point-${i}-${index}`}
          cx={position.x}
          cy={position.y}
          r={3}
          fill={series.color}
          stroke={series.color}
          strokeWidth={1}
        >
          <title>{`${axisConfig[index]?.name}: ${series[axisConfig[index]?.name]}`}</title>
        </circle>
      );
    });
    pointOut.push(points)
    return (
      <g key={`PathGroup${i}`}>
        <path
        key={`PathOfJoy${i}`}
        d={linePath}
        stroke={series.color}
        strokeWidth={3}
        fill={series.color}
        fillOpacity={0.2}
        />
        {/* {points} */}
      </g>
    );
  });
  return (
    <svg ref={svgRef} style={{ width: '100%', height: '100%' }}>
      <g transform={`translate(${dimensions.width / 2},${dimensions.height / 2})`}>
        <RadarGrid
          outerRadius={outerRadius}
          xScale={xScale}
          axisConfig={axisConfig}
          widthX={dimensions.width/2}
        />
        {allGroups}
        {pointOut}
      </g>
    </svg>
  );
};

export default SpiderChart;

//Funcion para obtener las cordenas cartecianas
const polarToCartesian = (angle: number, distance: number) => {
  const x = distance * Math.cos(angle);
  const y = distance * Math.sin(angle);
  return { x, y };
};
